// Barra de status de sincronização (SyncStatusBar).

export const pt = {
  failed: '{n} com falha',
  syncing: 'Sincronizando…',
  pending: '{n} pendente',
  pendingPlural: '{n} pendentes',
  allSynced: 'Tudo sincronizado',
};

export const es: typeof pt = {
  failed: '{n} con error',
  syncing: 'Sincronizando…',
  pending: '{n} pendiente',
  pendingPlural: '{n} pendientes',
  allSynced: 'Todo sincronizado',
};
